import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 6a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2","key":"svg-0"}],["path",{"d":"M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10","key":"svg-1"}],["path",{"d":"M10 12l4 0","key":"svg-2"}]]

const IconArchive = createReactComponent('outline', 'archive', 'Archive', __iconNode);

export default IconArchive;